import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

import Package from "../package.json";

const root = ReactDOM.createRoot(document.getElementById('layout'));
root.render(<App />);

globalThis.packageInfo = Package;

globalThis.savedProps = {};

const proxy = globalThis.packageInfo.proxy.replace("https://", "");
let socket = new WebSocket(`ws://${proxy}:8083/telfin-push`);

socket.onopen = function (e) {
    console.log("[open] Соединение установлено");
    console.log("Отправляем данные на сервер");
    socket.send("Меня зовут Джон");
};

socket.onmessage = function (event) {
    console.log(`[message] Данные получены с сервера: ${event.data}`);
};

socket.onclose = function (event) {
    if (event.wasClean) {
        console.log(`[close] Соединение закрыто чисто, код=${event.code} причина=${event.reason}`);
    } else {
        // например, сервер убил процесс или сеть недоступна
        // обычно в этом случае event.code 1006
        console.log('[close] Соединение прервано');
    }
};

socket.onerror = function (error) {
    console.log(`[error]`);
};
